<script lang="ts">
    import type { Splide } from "@splidejs/svelte-splide"
    import OptInBlock from "../OptInBlock.svelte"
    import MedialibImage from "../MedialibImage.svelte"
    import MedialibFile from "../MedialibFile.svelte"
    import { apiBaseOverride } from "../../store"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let slide: BlockHowItWorksSlide
    export let main: Splide = null
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !slide.hide}
    <div class="container-right bp-xxl tp-xxl" class:hidden="{!!slide.hide}">
        <!-- Klasse für rechts randauslaufenden Container -->
        <div class="grid gap-xl">
            <div class="col-md-4 flex-grow col-grid">
                <div class="content flex-grow">
                    {#if slide.headline}
                        <h2>{slide.headline}</h2>
                    {/if}
                    {#if slide.title}
                        <h3>{slide.title}</h3>
                    {/if}
                    <div class="text">
                        {@html slide.text}
                    </div>
                </div>
                {#if slide.callToAction?.buttonText}
                    <div class="button-wrap">
                        <a
                            href="{slide.callToAction.buttonLink}"
                            class="cta btn-primary"
                            target="{slide.callToAction.buttonTarget || undefined}">{slide.callToAction.buttonText}</a
                        >
                    </div>
                {/if}

                <!-- TODO: Titel next / prev Slide on Hover -->

                <div class="grid justify-space-between arrow-container tp-xl">
                    <button
                        class="splide-arrow splide-arrow-prev"
                        type="button"
                        aria-label="Previous slide"
                        aria-controls="splide01-track"
                        on:click="{() => main?.go('<')}"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 40 40"
                            width="40"
                            height="40"
                            focusable="false"
                            ><path
                                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
                            ></path></svg
                        >
                    </button>
                    <button
                        class="splide-arrow splide-arrow-next"
                        type="button"
                        aria-label="Next slide"
                        aria-controls="splide01-track"
                        on:click="{() => main?.go('>')}"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 40 40"
                            width="40"
                            height="40"
                            focusable="false"
                            ><path
                                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
                            ></path></svg
                        >
                    </button>
                </div>
            </div>
            <div class="col-md-7 col-bleed-right">
                {#if slide.youtubeLink}
                    <OptInBlock key="youtube" let:rejectCallback>
                        <iframe
                            title="{slide.title ? slide.title : 'Video'}"
                            class="video-embed shadow border-radius-left border-radius-xl"
                            src="{slide.youtubeLink.replace('youtu.be', 'www.youtube-nocookie.com/embed')}"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                        <div>
                            <!-- TODO: Über Opt Out sprechen -->
                            <button on:click="{rejectCallback}">Hide youtube content</button>
                        </div>
                        <div slot="placeholder" let:acceptCallback>
                            {#if slide.image}
                                <div
                                    class="background-image darken-background shadow border-radius-left border-radius-xl"
                                >
                                    <figure>
                                        <MedialibImage id="{slide.image}" />
                                    </figure>
                                </div>
                            {/if}
                            <div class="placeholder-message hp-xl">
                                This content is provided by YouTube. By enabling this content, your personal data may be
                                processed by the vendor and cookies may be set.
                                <button class="btn-primary" on:click="{acceptCallback}">Show youtube content</button>
                            </div>
                        </div>
                    </OptInBlock>
                {:else if slide.image}
                    <MedialibFile id="{slide.image}" let:entry let:src>
                        {#if entry.file?.type?.startsWith("video")}
                            <video class="shadow border-radius-left border-radius-xl" controls muted autoplay>
                                <source {src} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        {:else}
                            <div class="background-image shadow border-radius-left border-radius-xl">
                                <figure>
                                    <MedialibImage id="{slide.image}" />
                                </figure>
                            </div>
                        {/if}
                    </MedialibFile>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
</style>
